// 商品ページで追従するコンテンツにあわせてfooterの余白調整
function adjustFooterPadding() {
  const stickyBar = document.querySelector("product-sticky-bar");
  if (!stickyBar) return; // 存在しなければ終了

  const stickyHeight = stickyBar.getBoundingClientRect().height;

  const footerInner =
    document.querySelector("footer .footer") ||
    document.querySelector("footer");
  if (!footerInner) return;

  footerInner.style.paddingBlockEnd = `calc(${stickyHeight}px + 3.25rem)`;
}
document.addEventListener("DOMContentLoaded", adjustFooterPadding);
window.addEventListener("resize", adjustFooterPadding);

(function () {
  /* 属性が無いリンクは既定の挙動を変えたくないため opt-in にしている */
  const SELECTOR = 'a[href*="#"][data-smooth-scroll]';

  function focusTarget(target) {
    target.focus({ preventScroll: true });
    if (document.activeElement === target) return;

    // 見出しなど本来フォーカスできない要素にだけ付与する。枠線は CSS で消す
    target.setAttribute("tabindex", "-1");
    target.setAttribute("data-smooth-scroll-target", "");
    target.focus({ preventScroll: true });
  }

  function scrollToTarget(target) {
    // オフセットはベーステーマの html { scroll-padding-top } が効く
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    target.scrollIntoView({
      behavior: reduceMotion ? "instant" : "smooth",
      block: "start"
    });
  }

  document.addEventListener("click", event => {
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest(SELECTOR);
    if (!link) return;

    // link.hash は別ページ宛でも値を返すため、同名の id があると乗っ取ってしまう
    if (link.origin !== window.location.origin) return;
    if (link.pathname !== window.location.pathname) return;

    const hash = link.hash;
    if (!hash || hash === "#") return;

    let id = hash.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch {
      // 不正な % を含む hash はエンコードされたまま探す
    }

    const target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();

    // スクロール中に focus するとブラウザが smooth を打ち切る
    focusTarget(target);
    scrollToTarget(target);
    history.pushState(null, "", hash);
  });
})();
